// extracted by mini-css-extract-plugin
module.exports = {"timestamp":"TimeStamp_timestamp__70UTb","indicator":"TimeStamp_indicator__VAMCK","warning":"TimeStamp_warning__3UUah"};